// ตัวช่วยที่หน้ารายการใบคืนหอพัก หน้าใบรายคน และใบที่สั่งพิมพ์ ใช้ร่วมกัน
//
// แยกออกมาเพราะสามที่ต้องเรียกสิ่งเดียวกันด้วยคำเดียวกัน — ผลตรวจ "ไม่ผ่าน" ที่หน้าจอ
// ต้องเป็นคำเดียวกับที่พิมพ์บนใบที่ผู้ปกครองเซ็น ไม่งั้นจะเถียงกันว่าหมายถึงอะไร
import React from "react";
import { Badge } from "react-bootstrap";

// สาเหตุใช้รายการเดียวกับหน้าจำหน่ายนักเรียนของฝ่ายทะเบียน (WITHDRAW_REASONS)
// เพื่อให้ใบคืนหอพักกับทะเบียนการจำหน่ายบอกสาเหตุเดียวกัน — ย้ายโรงเรียนคือ
// ประเภท "จำหน่าย" + สาเหตุ "ย้ายสถานศึกษา" ไม่ใช่ประเภทที่สาม
export { WITHDRAW_REASONS, TYPE_LABEL, todayISO, toInputDate, reasonToForm }
  from "../registration/studentExitShared";

export const GROUPS = [
  { value: "return", label: "ของที่ต้องคืน" },
  { value: "condition", label: "สภาพห้องพักและครุภัณฑ์" },
  { value: "debt", label: "ค้างชำระ" },
];

export const groupLabel = (v) => GROUPS.find((g) => g.value === v)?.label || v;

export const RESULTS = [
  { value: "pass", label: "ผ่าน" },
  { value: "fail", label: "ไม่ผ่าน" },
  { value: "na", label: "ไม่มี/ไม่เกี่ยว" },
];

export const resultLabel = (v) => RESULTS.find((r) => r.value === v)?.label || "ยังไม่ตรวจ";

export const resultBadge = (v) => {
  if (v === "pass") return <Badge bg="success">ผ่าน</Badge>;
  if (v === "fail") return <Badge bg="danger">ไม่ผ่าน</Badge>;
  if (v === "na") return <Badge bg="secondary">ไม่มี/ไม่เกี่ยว</Badge>;
  return <Badge bg="warning">ยังไม่ตรวจ</Badge>;
};

export const STATUS_LABEL = {
  pending: "รอตรวจ/ตรวจอยู่",
  cleared: "เซ็นผ่านแล้ว",
  cancelled: "ยกเลิก",
};

export const statusBadge = (status) => {
  if (status === "cleared") return <Badge bg="success">เซ็นผ่านแล้ว</Badge>;
  if (status === "cancelled") return <Badge bg="secondary">ยกเลิก</Badge>;
  return <Badge bg="warning">รอตรวจ</Badge>;
};

export const baht = (v) =>
  Number(v || 0).toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// วันที่แบบไทยเต็ม ใช้บนหน้าจอ (ใบที่พิมพ์มีตัวของตัวเองใน print/ClearanceDoc)
const MONTHS = ["", "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
  "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];

// ค่า DATE จาก API เป็น Date object ที่ผ่าน JSON เป็น UTC ของเมื่อวาน 17:00Z —
// ต้องอ่านเป็นเวลาท้องถิ่น ไม่ใช่ slice(0,10) ของสตริง ไม่งั้นได้วันก่อนหน้าหนึ่งวัน
export const thaiDate = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return `${d.getDate()} ${MONTHS[d.getMonth() + 1]} ${d.getFullYear() + 543}`;
};
